import styled, { css } from 'styled-components'

import { TResponsiveProps, responsiveStyle } from '@hozana/styling/responsive'

import { Div, TDivProps } from 'elements/layout/Div'

const responsiveProps = { h: 'height' } as const

const rgbColors = {
  white: '255, 255, 255',
  background: '247, 247, 247',
}

export type TGradientMaskDivProps = {
  color?: keyof typeof rgbColors
  size?: string
  opacity?: string
} & TResponsiveProps<typeof responsiveProps> &
  TDivProps

export const GradientMaskDiv = styled(Div)<TGradientMaskDivProps>`
  &::before {
    pointer-events: none;
    content: '';
    position: absolute;
    z-index: 1;
    top: 0;
    left: -${({ size = '25px' }) => size};
    width: ${({ size = '25px' }) => size};
    ${({ h = '100%', ...props }) => responsiveStyle(responsiveProps)({ h, ...props })};
    ${({ color = 'white', opacity = '1' }) => css`
      background: linear-gradient(
        to right,
        rgba(${rgbColors[color]}, 0) 0%,
        rgba(${rgbColors[color]}, ${opacity}) 60%,
        rgba(${rgbColors[color]}, ${opacity}) 100%
      );
    `}
  }
`
